import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { userApi } from '../userApi';
import { type CreateUserRequest, type User } from '../types';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';
import { MutationKey } from '@shared/config';

export const useCreateUser = (): UseMutationResult<
  User,
  AxiosError<TFormErrorResponse>,
  CreateUserRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.CREATE_USER],
    mutationFn: (data: CreateUserRequest) => userApi.createUser(data),
  });
};
